import Listing from "../Listing";
import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchlessonWeaponPhysics } from "../../../redux/action/lessonsAction";
import SecureContent from "../../../components/secureContent";

const WeaponPhysics = () => {
  const dispatch = useDispatch();
  const { weaponPhysicsList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );
 
  useEffect(() => {
    dispatch(fetchlessonWeaponPhysics());
  }, []);


  if (isLoading) {
    return <Loader />;
  }
  
  return (
    <>
      <div>
      <SecureContent/>
      <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Weapon Physics"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Weapon Physics",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={weaponPhysicsList} color={"#2c3e96"} />

        <Footer />
      </div>
    </>
  );
};

export default WeaponPhysics;
